import {userStore} from "@/Stores/UserStore";

export class Permissions {
    // Checks if one or more permissions in permissionsNeeded array exists in userPermissions array
    static checkPermissions(permissionsNeeded, adminOnly = false) {
        const userPermissions = userStore.userInfo?.permissions || [];
        const isAdmin = userStore.userInfo?.isAdmin || false;

        // Skip this in Local environment
        if(import.meta.env.VUE_APP_ENVIRONMENT !== 'Local') {
            // Only users with azure admin group are allowed
            if (adminOnly === true && isAdmin !== true) {
                return false;
            }
        }

        // No permission needed
        if(permissionsNeeded.length === 0) {
            return true;
        }

        // Only 1 permission from permissions needs to be found in userPermissions
        for(let i = 0; i < permissionsNeeded.length; i++) {
            const permission = permissionsNeeded[i];

            if(userPermissions.includes(permission)) {
                return true;
            }

            // Check each level of permission, to see if user has a higher level permission. Ex: users instead of users.edit
            let index = permission.indexOf('.');
            while(index !== -1) {
                if(userPermissions.includes(`${permission.substring(0,index)}.*`)) {
                    return true;
                }

                index = permission.indexOf('.', index+1);
            }
        }

        return false;
    }

    // Returns whether or not this is an active directory user
    static isAdUser() {
        return userStore.userInfo?.adUser || false;
    }
}